module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_06-17cf590c3483d1855af94a1c4ae9a479.webp";